import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { MenuItem } from "@mui/material";
import IconButton from "@/components/Button/IconButton";
import Button from "@/components/Button";
import AddIcon from "@mui/icons-material/Add";

export const MembersCount = styled.p`
	font-size: 14px;
	line-height: 28px;
	margin-bottom: 16px;
`;

export const MembersOwnerWrapper = styled.div`
	display: flex;
`;

export const MembersOwnerText = styled.span`
	font-size: 14px;
	line-height: 28px;
	color: #545351;
`;

interface MembersOwnerChipProps {
	type: "owner" | "admin";
}

const ChipColors: Record<"owner" | "admin", string> = {
	owner: "#376FFF",
	admin: "#727272",
};

const ChipBackgroundColors: Record<"owner" | "admin", string> = {
	owner: "#E0E7FF",
	admin: "#EAEAEA",
};

export const MembersOwnerChip = styled.p<MembersOwnerChipProps>`
	font-size: 11px;
	line-height: 25px;
	font-weight: bold;
	height: 24px;
	padding: 0 10px;
	border-radius: 4px;
	margin-left: 10px;
	background-color: #dfdfdf;
	color: #6a6a6a;
	${({ type }) => css`
		color: ${ChipColors[type]};
		background-color: ${ChipBackgroundColors[type]};
	`}
`;

export const MemberMenuButton = styled(IconButton)`
	width: 30px;
	height: 30px;
`;

export const MemberMenuItem = styled(MenuItem)`
	font-size: 12px;
	color: #545351;
	font-weight: bold;
`;

export const MemberAddButton = styled(Button)`
	height: 32px;
	padding: 2px 12px;
	font-size: 14px;
`;

export const MemberAddButtonIcon = styled(AddIcon)`
	margin-left: 6px;
`;

export const ChangeMemberRoleModalTitle = styled.p`
	font-size: 18px;
	line-height: 2rem;
	font-weight: bold;
	margin-bottom: 14px;
`;

export const ChangeMemberRoleModalContent = styled.p`
	font-size: 14px;
	line-height: 22px;
	color: #676767;
`;
